$(document).ready(function() {
	$(document).trigger('site:ready');
});